var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C4.68567 2 2 4.68486 2 7.99544C2 11.306 4.68567 13.9909 8 13.9909C11.3143 13.9909 14 11.306 14 7.99544C14 4.68486 11.3143 2 8 2ZM0 7.99544C0 3.57906 3.58233 0 8 0C12.4177 0 16 3.57906 16 7.99544C16 12.4118 12.4177 15.9909 8 15.9909C3.58233 15.9909 0 12.4118 0 7.99544ZM8 3.99744C8.55228 3.99744 9 4.44515 9 4.99744V7.58102L10.7069 9.28678C11.0975 9.67718 11.0977 10.3103 10.7073 10.701C10.3169 11.0916 9.68377 11.0919 9.29312 10.7015L7.29312 8.70276C7.09934 8.5091 7.00163 8.25571 7.00002 8.00181H7V7.99601C7 7.99562 7 7.99522 7 7.99483V4.99744C7 4.44515 7.44772 3.99744 8 3.99744Z"
  })));
};
export default SvgClock;